// extracted by mini-css-extract-plugin
export default {"container":"XXppAw","track":"KYQ4kW","marquee":"pMerSr","item":"dFTIpo","colored":"AKoPPj","icon":"E4X18Q"};